import { useCallback, useState } from 'react';
import { DOCUMENTS } from 'hubspot-prosemirror/prosemirror/editorCapabilities';
import { useReactNodeView } from '../utils/ReactNodeView';
import DocumentPreviewTable from './documentPreview/DocumentPreviewTable';
import { buildDocumentPreviewTr } from '../utils/documentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentPreviewView = () => {
  var _node$attrs, _editorConfig$DOCUMEN;
  const {
    node,
    view,
    editorConfig
  } = useReactNodeView();
  const nodeAttrs = (_node$attrs = node === null || node === void 0 ? void 0 : node.attrs) !== null && _node$attrs !== void 0 ? _node$attrs : {};
  const [previewTitle, setPreviewTitle] = useState(nodeAttrs.previewTitle);
  const [description, setDescription] = useState(nodeAttrs.description);
  const [showEditPreview, setShowEditPreview] = useState(false);
  const updatePreview = useCallback(({
    title,
    desc
  }) => {
    if (view) {
      var _node$attrs2;
      const editorState = view.state;
      const currentAttrs = (_node$attrs2 = node === null || node === void 0 ? void 0 : node.attrs) !== null && _node$attrs2 !== void 0 ? _node$attrs2 : {};
      const tr = buildDocumentPreviewTr({
        documentId: parseInt(currentAttrs.documentId, 10),
        documentName: currentAttrs.documentName,
        requireEmail: currentAttrs.requireEmail,
        previewTitle: title,
        previewImage: currentAttrs.previewImage,
        description: desc,
        linkInfo: {
          url: currentAttrs.tokenTag,
          text: currentAttrs.tokenTag
        },
        includeLinkPreview: true,
        editorState,
        updateFromView: true,
        includePrefixedDocumentId: Boolean(currentAttrs.includePrefixedDocumentId)
      });
      // adding a delay to ensure the popover closes before the transaction is dispatched
      setTimeout(() => {
        view.dispatch(tr);
      }, 50);
    }
  }, [view, node]);
  const outputType = editorConfig === null || editorConfig === void 0 || (_editorConfig$DOCUMEN = editorConfig[DOCUMENTS]) === null || _editorConfig$DOCUMEN === void 0 ? void 0 : _editorConfig$DOCUMEN.outputType;
  return /*#__PURE__*/_jsx(DocumentPreviewTable, {
    documentId: nodeAttrs.documentId,
    previewImage: nodeAttrs.previewImage,
    previewTitle: previewTitle,
    description: description,
    setPreviewTitle: setPreviewTitle,
    setDescription: setDescription,
    documentName: nodeAttrs.documentName,
    showEditPreview: showEditPreview,
    setShowEditPreview: setShowEditPreview,
    editable: view === null || view === void 0 ? void 0 : view.editable,
    tokenTag: nodeAttrs.tokenTag,
    outputType: outputType,
    updatePreview: updatePreview
  });
};
export default DocumentPreviewView;
export const documentPreviewViewUpdateFn = ({
  previousNode,
  node
}) => {
  if (previousNode.attrs.documentId !== node.attrs.documentId || previousNode.attrs.previewTitle !== node.attrs.previewTitle || previousNode.attrs.description !== node.attrs.description) {
    return false;
  }
  return true;
};